/**
 * This is a special position for offer that is not available in the offer list.
 * This is also conveniently equal to the result of Array.findIndex method.
 * See issue: https://app.clickup.com/t/8698enymg
 */
export const OFFER_MODAL_OFFER_OUT_OF_SCOPE_POSITION = -1;
/**
 * This is a special position for offer that is not available in the offer list.
 * This is also conveniently equal to the result of Array.findIndex method.
 * See issue: https://app.clickup.com/t/8698enymg
 */
export const OFFER_MODAL_OFFER_OUT_OF_SCOPE_POSITION = -1;
